import { apiFetch } from "./client";

const normalizePreorderList = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.results)) return data.results;
  if (Array.isArray(data?.products)) return data.products;
  if (Array.isArray(data?.data)) return data.data;
  return [];
};

export const fetchPreorderProducts = async () =>
  normalizePreorderList(
    await apiFetch("/enduser/preorder-products/", {
      credentials: "include",
    })
  );

export const fetchPreorderProductById = (id) =>
  apiFetch(`/enduser/preorder-products/${id}/`, {
    credentials: "include",
  });
